export default __webpack_public_path__ + "static/media/soap.3832eeb2.png";